import React from "react";
import { useParams } from "react-router-dom"; // 👈 IMPORTANTE
import { makeStyles } from "@material-ui/core/styles";
import EventRegistryPublic from "./EventRegistryPublic";
import { Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
}));

export default function EventRegistry(props) {
  const {
    bgColor,
    eventLogo,
    image,
    imageMobile,
    title,
    renderType,
    eventIdDashport,
    textBottom,
    titlesColors,
  } = props.componentConfig;


  return (
    <div style={{ backgroundColor: bgColor }} id="topForm">
      <div id="topForm" style={{ height: "10px" }}></div>

      <EventRegistryPublic
        eventIdDashport={eventIdDashport} // 👈 usamos el final
        title={title}
        eventLogo={eventLogo}
        image={image}
        imageMobile={imageMobile}
        renderType={renderType}
        textBottom={textBottom}
        titlesColors={titlesColors}
      />
    </div>
  );
}

EventRegistry.displayName = "Vista para Incripciones a un evento";

export const componentDescription = {
  componentConfig: {
    eventLogo: {
      label: "Logo del registro",
      errorMessage: "",
      fieldName: "eventLogo",
      type: "photo",
      defaultValue: "",
      required: true,
      regex: "",
      textSize: "h6",
    },
    image: {
      label: "Imagen de inscripcion (Pantallas GRANDES)",
      errorMessage: "",
      fieldName: "image",
      type: "photo",
      defaultValue: "",
      required: true,
      regex: "",
      textSize: "h6",
    },
    imageMobile: {
      label: "Imagen de inscripcion (Dispositivos Móviles)",
      errorMessage: "",
      fieldName: "imageMobile",
      type: "photo",
      defaultValue: "",
      required: true,
      regex: "",
      textSize: "h6",
    },
    // eventIdDashport: {
    //   label: "ID del evento en Dashport",
    //   errorMessage: "",
    //   fieldName: "eventIdDashport",
    //   type: "text",
    //   defaultValue: "",
    //   required: true,
    //   regex: "",
    //   textSize: "h6",
    // },
    renderType: {
      label: "Tipo de vista a para mostra el formulario",
      errorMessage: "Campo Requerido",
      fieldName: "renderType",
      type: "select",
      defaultValue: "",
      required: true,
      regex: "",
      textSize: "h6",
      optionsArray: [
        { label: "Vista resumida", value: "view" },
        { label: "Vista resumida más Botón inferior", value: "viewandButton" },
        { label: "Vista detallada", value: "viewFull" },
        {
          label: "Vista detallada más Botón inferior",
          value: "viewFullandButton",
        },
        { label: "Imagen de Inscripciones", value: "image" },
        { label: "Botón de inscripciones", value: "button" },
      ],
    },

    title: {
      label: "Titulo de la sección",
      errorMessage: "",
      fieldName: "title",
      type: "text",
      defaultValue: "",
      required: true,
      regex: "",
      textSize: "h6",
    },
    textBottom: {
      label: "Texto al final de la sección",
      errorMessage: "",
      fieldName: "textBottom",
      type: "text",
      defaultValue: "",
      required: true,
      regex: "",
      textSize: "h6",
    },
    bgColor: {
      label: "Color de Fondo",
      errorMessage: "",
      fieldName: "bgColor",
      type: "color",
      defaultValue: "",
      required: true,
      regex: "",
      textSize: "h6",
    },
    titlesColors: {
      label: "Colores para resaltar los titulos de cada modalidad (Separa por punto y coma  cada color en el orden de las modalidades ejm #000000;#FFFFFF)",
      errorMessage: "",
      fieldName: "titlesColors",
      type: "text",
      defaultValue: "",
      required: false,
      regex: "",
      textSize: "h6",
      traducible: false,
    },
  },
};
